import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

declare global {
  interface Window {
    WOW: any;
  }
}

const OurMission: React.FC = () => {
  useEffect(() => {
    // Initialize data-background attributes
    const elements = document.querySelectorAll('[data-background]');
    elements.forEach((element) => {
      const bg = element.getAttribute('data-background');
      if (bg) {
        (element as HTMLElement).style.backgroundImage = `url(${bg})`;
      }
    });

    // Initialize WOW.js for scroll animations
    if (window.WOW) {
      const wow = new window.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    }
  }, []);

  return (
    <>
      {/* Page banner area start here */}
      <section className="banner__inner-page bg-image pt-160 pb-160"
        data-background="/assets/images/banner/banner-inner-page.jpg">
        <div className="container">
          <h2 className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">Our Mission</h2>
          <div className="breadcrumb-list wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
            <Link to="/">Home</Link>
            <span><i className="fa-regular fa-angles-right mx-2"></i></span>
            <Link to="/about">About Us</Link>
            <span><i className="fa-regular fa-angles-right mx-2"></i>Our Mission</span>
          </div>
        </div>
      </section>
      {/* Page banner area end here */}

      {/* Mission area start here */}
      <section className="pt-120 pb-120">
        <div className="container">
          {/* Mission Statement */}
          <div className="row justify-content-center mb-60">
            <div className="col-lg-10">
              <div className="section-header text-center mb-40 wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                <h5>
                  <i className="fa-regular fa-angles-left pe-1"></i> OUR MISSION <i className="fa-regular fa-angles-right ps-1"></i>
                </h5>
                <h2 style={{ color: '#0C2239', fontSize: '42px', marginTop: '20px' }}>
                  Giving Every Child What They Truly Deserve
                </h2>
              </div>
              
              <div className="wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                <div style={{
                  padding: '40px',
                  background: 'linear-gradient(135deg, #03A84A 0%, #01944B 100%)',
                  borderRadius: '15px',
                  color: 'white',
                  textAlign: 'center',
                  boxShadow: '0 10px 40px rgba(247, 79, 34, 0.2)'
                }}>
                  <i className="fa-solid fa-heart" style={{ fontSize: '48px', marginBottom: '20px', display: 'block' }}></i>
                  <p style={{ 
                    fontSize: '22px', 
                    lineHeight: '1.8', 
                    color: 'white',
                    margin: 0,
                    fontWeight: '500'
                  }}>
                    Our mission is to provide consistent, compassionate, and practical care to every child in need. We believe that every child deserves <strong>true happiness</strong>, a <strong>better shelter</strong>, a <strong>healthy lifestyle</strong>, and <strong>proper care</strong>. While we are giving them these essentials now, our unwavering commitment is to provide them to the <strong>fullest extent possible</strong>.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Core Mission Elements */}
          <div className="row g-4 mb-60">
            <div className="col-lg-6 wow fadeInLeft" data-wow-delay="00ms" data-wow-duration="1500ms">
              <div style={{
                height: '100%',
                padding: '35px',
                backgroundColor: '#FFF5F2',
                borderRadius: '12px',
                borderLeft: '5px solid #03A84A'
              }}>
                <div style={{ marginBottom: '20px' }}>
                  <div style={{
                    width: '70px',
                    height: '70px',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '20px'
                  }}>
                    <i className="fa-solid fa-face-smile" style={{ fontSize: '36px', color: '#03A84A' }}></i>
                  </div>
                  <h3 style={{ color: '#0C2239', fontSize: '28px', fontWeight: '700', marginBottom: '15px' }}>
                    True Happiness
                  </h3>
                  <p style={{ color: '#6F7174', fontSize: '16px', lineHeight: '1.8' }}>
                    Every child deserves to experience genuine joy and emotional well-being. We create an environment filled with love, laughter, and positive experiences where children can simply be children—playing, learning, and growing without fear or worry. Through activities, celebrations, and daily moments of care, we ensure that happiness is not just a fleeting emotion but a fundamental part of their lives.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-6 wow fadeInRight" data-wow-delay="200ms" data-wow-duration="1500ms">
              <div style={{
                height: '100%',
                padding: '35px',
                backgroundColor: '#FFF5F2',
                borderRadius: '12px',
                borderLeft: '5px solid #03A84A'
              }}>
                <div style={{ marginBottom: '20px' }}>
                  <div style={{
                    width: '70px',
                    height: '70px',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '20px'
                  }}>
                    <i className="fa-solid fa-house-heart" style={{ fontSize: '36px', color: '#03A84A' }}></i>
                  </div>
                  <h3 style={{ color: '#0C2239', fontSize: '28px', fontWeight: '700', marginBottom: '15px' }}>
                    Better Shelter
                  </h3>
                  <p style={{ color: '#6F7174', fontSize: '16px', lineHeight: '1.8' }}>
                    A safe, comfortable, and nurturing home is not a luxury—it's a necessity. We provide more than just four walls and a roof; we create a space where children feel secure, protected, and truly at home. Our facilities are designed with their needs in mind, offering clean, comfortable living spaces where they can rest, play, and grow in a stable environment that promotes their overall development.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-6 wow fadeInLeft" data-wow-delay="00ms" data-wow-duration="1500ms">
              <div style={{
                height: '100%',
                padding: '35px',
                backgroundColor: '#FFF5F2',
                borderRadius: '12px',
                borderLeft: '5px solid #03A84A'
              }}>
                <div style={{ marginBottom: '20px' }}>
                  <div style={{
                    width: '70px',
                    height: '70px',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '20px'
                  }}>
                    <i className="fa-solid fa-heart-pulse" style={{ fontSize: '36px', color: '#03A84A' }}></i>
                  </div>
                  <h3 style={{ color: '#0C2239', fontSize: '28px', fontWeight: '700', marginBottom: '15px' }}>
                    Healthy Lifestyle
                  </h3>
                  <p style={{ color: '#6F7174', fontSize: '16px', lineHeight: '1.8' }}>
                    Good health is the foundation of a fulfilling life. We ensure every child receives nutritious meals, regular medical checkups, proper hygiene support, and access to therapeutic activities. Our holistic approach addresses both physical and mental health, promoting habits and routines that will serve them throughout their lives. We believe that a healthy body and mind are essential for every child to reach their full potential.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-6 wow fadeInRight" data-wow-delay="200ms" data-wow-duration="1500ms">
              <div style={{
                height: '100%',
                padding: '35px',
                backgroundColor: '#FFF5F2',
                borderRadius: '12px',
                borderLeft: '5px solid #03A84A'
              }}>
                <div style={{ marginBottom: '20px' }}>
                  <div style={{
                    width: '70px',
                    height: '70px',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '20px'
                  }}>
                    <i className="fa-solid fa-hand-holding-heart" style={{ fontSize: '36px', color: '#03A84A' }}></i>
                  </div>
                  <h3 style={{ color: '#0C2239', fontSize: '28px', fontWeight: '700', marginBottom: '15px' }}>
                    Proper Care
                  </h3>
                  <p style={{ color: '#6F7174', fontSize: '16px', lineHeight: '1.8' }}>
                    Every child in our care receives individualized attention from trained, compassionate caretakers who understand their unique needs. Whether it's helping with daily activities, providing educational support, administering medication, or simply offering a comforting presence, we ensure that no child's needs go unmet. Our care extends beyond the physical—we nurture their emotional, social, and intellectual development every single day.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Our Commitment Section */}
          <div className="row justify-content-center mb-60">
            <div className="col-lg-10">
              <div className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                <div style={{
                  padding: '40px',
                  backgroundColor: 'white',
                  borderRadius: '15px',
                  border: '2px solid #03A84A',
                  boxShadow: '0 5px 30px rgba(0, 0, 0, 0.08)'
                }}>
                  <div className="text-center mb-30">
                    <i className="fa-solid fa-shield-heart" style={{ fontSize: '48px', color: '#03A84A', marginBottom: '15px' }}></i>
                    <h3 style={{ color: '#0C2239', fontSize: '32px', fontWeight: '700', marginBottom: '20px' }}>
                      Our Unwavering Commitment
                    </h3>
                  </div>
                  <p style={{ color: '#6F7174', fontSize: '17px', lineHeight: '1.9', textAlign: 'center', marginBottom: '20px' }}>
                    While we are proud of the care we currently provide, we recognize that there is always room for improvement. Our mission is not static—it is a living commitment that drives us to continuously enhance our services, expand our facilities, and reach more children in need.
                  </p>
                  <p style={{ color: '#6F7174', fontSize: '17px', lineHeight: '1.9', textAlign: 'center' }}>
                    We dream of a future where every child under our care has access to the best possible resources, where no need goes unaddressed, and where every opportunity for growth and development is made available. This is not just our goal—it is our promise.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* What We Strive For */}
          <div className="row mb-60">
            <div className="col-12">
              <div className="section-header text-center mb-40 wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                <h5>
                  <i className="fa-regular fa-angles-left pe-1"></i> OUR GOALS <i className="fa-regular fa-angles-right ps-1"></i>
                </h5>
                <h2 style={{ color: '#0C2239', fontSize: '36px', marginTop: '20px' }}>
                  What We Strive to Achieve
                </h2>
              </div>
            </div>
          </div>

          <div className="row g-4 mb-60">
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
              <div style={{
                height: '100%',
                padding: '30px',
                backgroundColor: 'white',
                borderRadius: '12px',
                boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.3s ease',
                cursor: 'pointer'
              }}
              className="mission-card">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: '#FFF5F2',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}>
                  <i className="fa-solid fa-graduation-cap" style={{ fontSize: '28px', color: '#03A84A' }}></i>
                </div>
                <h5 style={{ color: '#0C2239', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                  Quality Education
                </h5>
                <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>
                  Ensure every child receives quality education that prepares them for a bright future, regardless of their challenges or circumstances.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="100ms" data-wow-duration="1500ms">
              <div style={{
                height: '100%',
                padding: '30px',
                backgroundColor: 'white',
                borderRadius: '12px',
                boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.3s ease',
                cursor: 'pointer'
              }}
              className="mission-card">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: '#FFF5F2',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}>
                  <i className="fa-solid fa-kit-medical" style={{ fontSize: '28px', color: '#03A84A' }}></i>
                </div>
                <h5 style={{ color: '#0C2239', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                  Comprehensive Healthcare
                </h5>
                <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>
                  Provide access to medical professionals, therapeutic services, and preventive care to maintain optimal health for every child.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
              <div style={{
                height: '100%',
                padding: '30px',
                backgroundColor: 'white',
                borderRadius: '12px',
                boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.3s ease',
                cursor: 'pointer'
              }}
              className="mission-card">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: '#FFF5F2',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}>
                  <i className="fa-solid fa-users" style={{ fontSize: '28px', color: '#03A84A' }}></i>
                </div>
                <h5 style={{ color: '#0C2239', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                  Social Development
                </h5>
                <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>
                  Foster social skills, emotional intelligence, and meaningful relationships that help children integrate into society.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
              <div style={{
                height: '100%',
                padding: '30px',
                backgroundColor: 'white',
                borderRadius: '12px',
                boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.3s ease',
                cursor: 'pointer'
              }}
              className="mission-card">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: '#FFF5F2',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}>
                  <i className="fa-solid fa-lightbulb" style={{ fontSize: '28px', color: '#03A84A' }}></i>
                </div>
                <h5 style={{ color: '#0C2239', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                  Life Skills Training
                </h5>
                <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>
                  Equip children with practical life skills that promote independence and prepare them for successful futures.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="100ms" data-wow-duration="1500ms">
              <div style={{
                height: '100%',
                padding: '30px',
                backgroundColor: 'white',
                borderRadius: '12px',
                boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.3s ease',
                cursor: 'pointer'
              }}
              className="mission-card">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: '#FFF5F2',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}>
                  <i className="fa-solid fa-hand-holding-heart" style={{ fontSize: '28px', color: '#03A84A' }}></i>
                </div>
                <h5 style={{ color: '#0C2239', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                  Emotional Support
                </h5>
                <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>
                  Create a nurturing environment where children feel loved, valued, and supported through every challenge they face.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
              <div style={{
                height: '100%',
                padding: '30px',
                backgroundColor: 'white',
                borderRadius: '12px',
                boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.3s ease',
                cursor: 'pointer'
              }}
              className="mission-card">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: '#FFF5F2',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}>
                  <i className="fa-solid fa-infinity" style={{ fontSize: '28px', color: '#03A84A' }}></i>
                </div>
                <h5 style={{ color: '#0C2239', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                  Long-term Sustainability
                </h5>
                <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>
                  Build sustainable programs that ensure continuous care and support for generations of children to come.
                </p>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                <div style={{
                  padding: '50px',
                  background: 'linear-gradient(135deg, #03A84A 0%, #01944B 100%)',
                  borderRadius: '15px',
                  textAlign: 'center',
                  color: 'white'
                }}>
                  <i className="fa-solid fa-hands-holding-circle" style={{ fontSize: '56px', marginBottom: '20px', display: 'block' }}></i>
                  <h3 style={{ color: 'white', fontSize: '32px', fontWeight: '700', marginBottom: '20px' }}>
                    Help Us Achieve Our Mission
                  </h3>
                  <p style={{ fontSize: '18px', color: 'rgba(255, 255, 255, 0.95)', lineHeight: '1.8', marginBottom: '30px', maxWidth: '800px', margin: '0 auto 30px' }}>
                    Our mission is ambitious, but with your support, it is achievable. Every contribution, whether big or small, brings us one step closer to giving every child what they truly deserve. Join us in making a lasting difference in the lives of children who need it most.
                  </p>
                  <Link 
                    to="/contact"
                    style={{
                      display: 'inline-block',
                      padding: '18px 50px',
                      backgroundColor: 'white',
                      color: '#03A84A',
                      fontSize: '18px',
                      fontWeight: '600',
                      borderRadius: '50px',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 5px 20px rgba(0, 0, 0, 0.2)'
                    }}
                  >
                    <i className="fa-solid fa-heart" style={{ marginRight: '10px' }}></i>
                    Support Our Mission
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Mission area end here */}

      <style>{`
        .mission-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 30px rgba(247, 79, 34, 0.15) !important;
        }
      `}</style>
    </>
  );
};

export default OurMission;
